/*
* @Author: zhangzhitao
* @Date: 2019-05-28 18:53:22
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-07-19 15:31:46
*/

<template>
  <div
    class="container bg-upload"
    :class="{'nodashed':file.path !== ''}"
    ref="container"
  >
    <el-upload
      v-if="this.file.fileId === '-1'"
      :action="uploadSrc"
      name="zipFile"
      class="bg-upload m-upload"
      :show-file-list="false"
      :data="uploadData"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :before-upload="beforeUpload"
    >
      <i class="h-icon-add icon"></i>
    </el-upload>
    <div
      class="img-show"
      v-else
    >
      <lottie
        :options="defaultOptions"
        :key="dateTime"
        :dateTime="dateTime"
      ></lottie>
      <div class="operator-wrapper">
        <div class="buttons">
          <i
            class="btn h-icon-delete"
            @click="removeImage"
          ></i>
          <el-upload
            :action="uploadSrc"
            class="bg-upload-replace"
            name="zipFile"
            :show-file-list="false"
            :data="uploadData"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
          >
            <i class="btn h-icon-update"></i>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configuration from 'api/config'
import API from 'api/api'
import lottie from 'components/lottie/lottie'
import { LoadingMixin } from 'utils/mixin'
import axios from 'axios'

export default {
  name: 'animat-upload',
  model: {
    prop: 'file',
    event: 'change'
  },
  props: {
    type: String,
    file: {
      type: Object,
      default () {
        return {
          fileId: '-1',
          path: '',
          width: '',
          height: ''
        }
      }
    }
  },
  computed: {
    uploadSrc () {
      return `${configuration.baseUrl}${configuration.uploadZip}`
    },
    uploadData () {
      return {
        usageScenario: this.type
      }
    },
    showStyle () {
      let _res = {
        'background-image': `url(${this.file.path})`
      }
      let _width = this.file.width ? parseInt(this.file.width) : 0
      if (_width > 0 && _width < 15) {
        _res['background-repeat'] = 'repeat-x'
      }
      return _res
    }
  },
  components: { lottie },
  data () {
    return {
      loadingInstance: null,
      defaultOptions: {},
      dateTime: new Date().getTime()
    }
  },
  mounted () {
    this.getAnimatJson()
  },
  methods: {
    beforeUpload (file) {
      if (!/.(zip|ZIP)$/.test(file.name)) {
        this.$message.error(this.$t('common.animate_type_error'))
        return false
      }
      this.loadingInstance = this._getLoading()
      API.common.keepAlive()
      return true
    },
    uploadSuccess (response, file) {
      this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.animate_upload_success'))
        this.$emit('change', {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        })
      } else {
        this.$message.error(response.msg)
      }
    },
    uploadFail () {
      this.loadingInstance.close()
      this.$message.error(this.$t('common.upload_error'))
    },
    removeImage () {
      this.$emit('change', {
        fileId: '-1',
        path: '',
        width: 0,
        height: 0
      })
    },
    async getAnimatJson () {
      if (this.file.fileId !== '-1') {
        const requestUrl = this.file.path
        const animatJson = await axios.get(requestUrl)
        for (let i = 0; i < animatJson.data.assets.length; i++) {
          if (animatJson.data.assets[i].u) {
            animatJson.data.assets[i].u = `${process.env.VUE_APP_BASEURL}/zip/dynamicDisplay/${this.file.fileId}/images/`
          } else {
            break
          }
        }
        this.dateTime = new Date().getTime()
        this.defaultOptions = { animationData: animatJson.data }
      }
    }
  },
  mixins: [LoadingMixin],
  watch: {
    'file.fileId' () {
      this.$nextTick(() => {
        this.getAnimatJson()
      })
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.bg-upload.container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  &.nodashed {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  .bg-upload {
    position: relative;
    width: 100%;
    height: 100%;
    .icon {
      font-size: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .img-show {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background: url("../../../assets/images/bg_logo.png");
    position: relative;
    .operator-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: none;
      .buttons {
        width: 48px;
        height: 24px;
        font-size: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        .btn {
          font-size: 24px;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.8);
        }
        /deep/ .bg-upload-replace {
          width: 24px;
          height: 24px;
          overflow: hidden;
          display: inline-block;
        }
      }
    }
    &:hover {
      .operator-wrapper {
        display: block;
      }
    }
  }
}
</style>
